export default __webpack_public_path__ + "static/media/swap_active.1d3428d2.svg";